import "./MatchKeyEventComponents.css";

import { ISoccerMatchGoalEvent } from "../../../../../../../types";

export const GoalEvent = ({
  event,
  isHomeTeamEvent,
  isAwayTeamEvent,
}: {
  event: ISoccerMatchGoalEvent;
  isHomeTeamEvent: boolean;
  isAwayTeamEvent: boolean;
}) => {
  let goalImgSrc = "";
  if (event.type === "G") {
    goalImgSrc = "/images/match-events/goal.svg";
  } else if (event.type === "PG") {
    goalImgSrc = "/images/match-events/penalty-goal.svg";
  } else if (event.type === "OG") {
    goalImgSrc = "/images/match-events/goal.svg";
  }
  const ownGoal = event.type === "OG";
  return (
    <div className="match-key-event">
      <span className="home-team-match-key-event">
        {((isHomeTeamEvent && !ownGoal) || (!isHomeTeamEvent && ownGoal)) && (
          <>
            <span className="event-player-name">
              {event.scorerName}
              {event.type === "OG" ? " (OG)" : ""}
            </span>
            <img
              src={goalImgSrc}
              height={16}
              width={16}
              alt={"goal"}
              className="goal-event"
            />
          </>
        )}
      </span>
      <span className="time-match-key-event">{`${event?.timeMin}'`}</span>
      <span className="away-team-match-key-event">
        {((isAwayTeamEvent && !ownGoal) || (!isAwayTeamEvent && ownGoal)) && (
          <>
            <img
              src={goalImgSrc}
              height={16}
              width={16}
              alt={"goal"}
              className="goal-event"
            />
            <span className="event-player-name">
              {event.scorerName}
              {event.type === "OG" ? " (OG)" : ""}
            </span>
          </>
        )}
      </span>
    </div>
  );
};
